import { FC, useState } from "react";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import { Box } from "@mui/material";
import ImgBg from "../../assets/images/products/thematic-data/bg-data-card.png";
import { useStyles } from "./styles";

interface Props {
  image: any;
  title: string;
  text: string;
  reverseTexts: string[];
}

const ThematicDataCarouselCard: FC<Props> = ({
  image,
  title,
  text,
  reverseTexts,
}) => {
  const classes = useStyles();
  const [flipped, setFlipped] = useState<boolean>(false);

  const toggleFlipped = () => setFlipped(!flipped);

  return (
    <Box className={classes.cardContainer}>
      <Box sx={{ zIndex: -1 }}>
        <img src={image} alt={title} />
      </Box>

      <Box
        className={classes.cardTextMain}
        sx={{
          height: flipped ? "auto" : "19rem",
          backgroundImage: `url(${ImgBg})`,
        }}
      >
        {!flipped && <Box className={classes.cardTitle}>{title}</Box>}
        {flipped ? (
          <Box className={classes.cardTextFlipped}>
            <ul className={classes.list}>
              {reverseTexts.map((str, idx) => (
                <li key={str + idx}>{str}</li>
              ))}
            </ul>
          </Box>
        ) : (
          <Box className={classes.cardTextNotFlipped}>{text}</Box>
        )}
        <Box
          className={classes.cardAction}
          sx={{
            borderColor: flipped ? "#fff" : "transparent",
            padding: flipped ? "0.5rem" : "0.5rem 0",
          }}
          onClick={toggleFlipped}
        >
          {flipped ? (
            <>
              <Box className={classes.footerActionLabel}>Return</Box>
              <Box className={classes.iconWrapper}>
                <KeyboardArrowLeftIcon htmlColor="#fff" />
              </Box>
            </>
          ) : (
            <>
              <Box className={classes.footerActionLabel}>Themes</Box>
              <Box
                className={classes.iconWrapper}
                sx={{
                  backgroundColor: "#fff",
                }}
              >
                <KeyboardArrowRightIcon htmlColor="#792785" />
              </Box>
            </>
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default ThematicDataCarouselCard;
